import react, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import { constants } from '../../util'
import { useSelector, useDispatch } from 'react-redux';
import { showPasswordRecovery, showWaiting } from '../../store/slices/configSlice';
import WizardCreateAccount from '../../components/util/WizardCreateAccount';

import { useTranslation } from 'react-i18next';
import i18next from 'i18next'

import GoogleSignIn from '../../components/auth/GoogleSignIn';
import WizardPasswordRecovery from '../../components/util/WizardPasswordRecovery';


import {
    passwordRecovery_IsValidAccount,
    passwordRecovery_ResendCode,
    passwordRecovery_CodeValidation,
    passwordRecovery_SetNewPassword
} from '../../services/securityService';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'

import { enqueueSnackbar } from 'notistack';


const Root = styled('div')(({ theme }) => ({
  width: '100%',
  ...theme.typography.body2,
  color: (theme.vars || theme).palette.text.secondary,
  '& > :not(style) ~ :not(style)': {
    marginTop: theme.spacing(2),
  },
}));





export default function PasswordRecovery() {
    const {language, openPasswordRecovery} = useSelector( state => state.configuration);
    const dispatch = useDispatch();
    const [step, setStep] = useState(0);
    const [emailState, setEmailState] = useState(null);
    const [codeState, setCodeState] = useState(null);
    const [errorValidations, setErrorValidations] = useState([]);

    //TRANSLATION
    const [t, i18n] = useTranslation("global");
    
    const sch = (yup) => yup.object({
        email: yup.string().email().required(),
        verificationCode: yup.number().required(),
        password: yup.string().required().min(8).max(20),
        passwordConfirm: yup.string().required().min(8).max(20),
    });
    const schema = useYupSchema(sch);


    const validatePassword = (pwd) => {
        console.log(language);
        
        const rules = [
            { test: pwd.length >= 8 && pwd.length <= 15, message: language==='es' ? 'La contraseña debe tener entre 8 y 15 caracteres' : 'Password must have between 8 and 15 characters' },
            { test: /[A-Z]/.test(pwd), message: language==='es' ? 'Debe incluir al menos 1 mayúscula' : 'Must include at least 1 capital letter' },
            { test: /[a-z]/.test(pwd), message: language==='es' ? 'Debe incluir al menos 1 minúscula' : 'Must include at least 1 lowercase letter' },
            { test: /\d/.test(pwd), message: language==='es' ? 'Debe incluir al menos 1 número' : 'Must include at least 1 number' },
            { test: /[*.,\-_/()%$#]/.test(pwd), message: language==='es' ? 'Debe incluir al menos 1 símbolo (*.,-_/()%$#)' : 'Must include at least 1 symbol (*.,-_/()%$#)' },
        ];

        return rules.filter(rule => !rule.test);
    };


    const handleClose = () => {
        dispatch(showPasswordRecovery(false));
        reset();
        setStep(0);
    }

    const handlePrev = () => {
        if (step-1 >= 0)
            setStep(step-1)
        else
            setStep(3)
    }
    
    const handleContinue = () => {
        if (step+1 <= 3)
            setStep(step+1)
        else
            setStep(0)
    }

    const steps = [
        {
            step: 0,
            text: t("passwordRecovery.textStep1"),
            imgKey: 'pr-01.svg'
        },
        {
            step: 1,
            text: t("passwordRecovery.textStep2"),
            imgKey: 'pr-02.svg'
        },
        {
            step: 2,
            text: t("passwordRecovery.textStep3"),
            imgKey: 'pr-03.svg'
        },
        {
            step: 3,
            text: t("passwordRecovery.textStep4"),
            imgKey: 'pr-04.svg'
        }
    ];

    const onSubmit = (data) => {}

    const { register, handleSubmit, reset, getValues, formState: { errors } } = useForm({
            resolver: yupResolver(schema),
        });

    
    const handleClick_Previous = () => {
        handlePrev();
        reset();
    }

    const handleClick_Next = () => {
        if (step===0){
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const email = getValues('email');
            
            if (emailRegex.test(email)){
                passwordRecovery_IsValidAccount(email)
                    .then(rsp => {
                        if (rsp.code === '00'){
                            setEmailState(email);
                            handleContinue();
                        }
                        else{
                            enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                        }
                    })
                    .catch(
                        error => console.log(error)
                    );
            }
            else
                enqueueSnackbar(language==='es'
                        ? 'Cuenta de correo no válida'
                        : 'Email account not valid', { variant: 'error', persist: false });
        }
        else if(step==1){
            const verificationCode = getValues('verificationCode');
            passwordRecovery_CodeValidation(emailState, verificationCode)
                .then(rsp => {
                    if (rsp.code === '00'){
                        setCodeState(verificationCode);
                        handleContinue();
                    }
                    else{
                        enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                    }
                });
        }
        else if(step==2){
            const psw = getValues('password');
            const pswConfirm = getValues('passwordConfirm');

            if (psw===pswConfirm){
                const arrValidations = validatePassword(pswConfirm);
                if (arrValidations.length > 0){
                    setErrorValidations(arrValidations);
                    // dispatch(showWaiting(false));
                }
                else{
                    setErrorValidations([]);
                    passwordRecovery_SetNewPassword(emailState, codeState, psw)
                        .then(rsp => {
                            if (rsp.code === '00'){
                                handleContinue();
                            }
                            else{
                                enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                            }
                        });
                }
            }
            else{
                enqueueSnackbar(
                    language==='es'
                        ? 'Las contraseñas no coinciden'
                        : 'Passwords are not equal'
                , { variant: 'error', persist: false });
            }
        }
    }

    const handleClick_ResendCode = () => {
        if (step===1){
            passwordRecovery_ResendCode(emailState)
                .then(rsp => {
                    if (rsp.code === '00'){
                        enqueueSnackbar(rsp.message, { variant: 'success', persist: false });
                    }
                    else{
                        enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                    }
                });
        }
    }


    return(
        <>
            <Modal
                open={openPasswordRecovery}
                onClose={()=>handleClose()}
            >
                <Box sx={{ ...constants.styles.modalBox,
                    width: {
                        sxs: '95%', 
                        xs: '95%',  // Celular-vertical
                        sm: '80%',  // Ipad Vertical
                        md: '50%',  // Ipad Horizontal
                        lg: '50%',  // Laptop-PC
                        xl: '50%',  // Laptop-PC,
                    },
                    maxwidth: {
                        sxs: '400px', 
                        xs: '400px',  // Celular-vertical
                        sm: '700px',  // Ipad Vertical
                        md: '700px',  // Ipad Horizontal
                        lg: '700px',  // Laptop-PC
                        xl: '700px',  // Laptop-PC,
                    },
                    height:  '97%',
                    minHeight: '350px',
                    maxHeight: '470px',
                    
                    // backgroundColor:{
                    //     sxs: 'purple',
                    //     xs: 'pink',
                    //     sm: 'green',
                    //     md: 'red',
                    //     lg: 'blue',
                    //     xl: 'brown'
                    // }
                }}
                >
                    
                        <Grid container spacing={0} sx={{height: '100%'}}>
                            <Grid size={{sxs: 0, xs:0, sm:5, md:5, lg:5, xl:5}} 
                                sx={{ display: {sxs: 'none', xs:'none', sm:'block', md:'block', lg:'block', xl:'block'},
                                    height: '100%',
                                    backgroundImage: `url(/assets/img/generic/${steps[step].imgKey})`,
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    backgroundSize: "cover",
                                    borderTopLeftRadius: 12,
                                    borderBottomLeftRadius: 12
                                }}
                            >
                            </Grid>
                            
                            <Grid container direction="column" spacing={0} size={{sxs:12, xs:12, sm:7, md:7, lg:7, xl:7}} 
                                sx={{
                                    paddingLeft: '25px',
                                    paddingRight: '25px',
                                    paddingTop: '15px',
                                    paddingBottom: '15px',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    // alignItems: "center",
                                }}
                            >
                                <form onSubmit={handleSubmit(onSubmit)} 
                                    style={{height:'100%', display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',}}
                                >
                                    <Box sx={{display: 'flex', flexDirection: 'column',  width: '100%', maxHeight: '85%', overflow: 'auto'}}>
                                        <div style={{display: (step===3 ? 'none': 'block')}}>
                                            <Grid container direction={'column'} size={12} sx={{alignContent: 'center', marginBottom: '20px'}}>
                                                <Typography sx={{fontWeight: 'bold', fontSize: '20px'}}>{t("passwordRecovery.title")}</Typography>
                                            </Grid>
                                            <Grid container direction={'column'} size={12} sx={{alignContent: 'center', marginBottom: '50px'}}>
                                                <WizardPasswordRecovery step={step} text={steps[step].text} />
                                            </Grid>
                                        </div>
                                        <Grid container direction={'column'} size={12} sx={{alignContent: 'center', marginBottom: '0px', width: '100%'}}>
                                            <div id="paso1" style={{display: (step===0 ? 'block': 'none'), width: '100%'}}>
                                                <TextField id="txtEmail" label={t("passwordRecovery.email")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield}} 
                                                    {...register('email')}
                                                    error={!!errors.email}
                                                    helperText={errors.email?.message}
                                                />
                                            </div>
                                            <div id="paso2" style={{display: (step===1 ? 'block': 'none')}}>
                                                <Typography sx={{fontSize: '11px'}}>{t("passwordRecovery.descVerificationCode")}</Typography>
                                                <br />
                                                <TextField id="txtVerificactionCode" label={t("passwordRecovery.verificationCode")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                                    {...register('verificationCode')}
                                                    error={!!errors.verificationCode}
                                                    helperText={errors.verificationCode?.message}
                                                />
                                                <Button variant="text" sx={{ ...constants.styles.linkButton, fontSize: '11px' }} onClick={()=>handleClick_ResendCode()}>{t("passwordRecovery.sendVerificationCode")}</Button>
                                            </div>
                                            <div id="paso3" style={{display: (step===2 ? 'block': 'none')}}>
                                                <TextField id="txtPassword" label={t("passwordRecovery.password")} type="password" autoComplete="current-password" variant="outlined" margin="dense" fullWidth 
                                                    {...register('password')}
                                                    error={!!errors.password}
                                                    helperText={errors.password?.message}
                                                />
                                                <TextField id="txtPasswordConfirm" label={t("passwordRecovery.passwordConfirm")} type="password" autoComplete="current-password" variant="outlined" margin="dense" fullWidth  
                                                    {...register('passwordConfirm')}
                                                    error={!!errors.passwordConfirm}
                                                    helperText={errors.passwordConfirm?.message}
                                                />
                                                {
                                                    errorValidations.map(error => (
                                                        <Typography key={error.message} sx={{color:'red', fontSize:'12px'}}>{error.message}</Typography>
                                                    ))
                                                }
                                            </div>
                                            <div id="paso4" style={{display: (step===3 ? 'block': 'none')}}>
                                                <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', width: '100%'}}>
                                                    <img src="/assets/img/logo/logo-black.svg" style={{width: '60%'}} />
                                                    <br /><br /><br />
                                                    {
                                                        language == 'es' ?
                                                            <img src={`/assets/img/generic/felicidades.png`} style={{width: '70%'}} />
                                                        :
                                                            null
                                                    }
                                                    {
                                                        language == 'en' ?
                                                            <img src={`/assets/img/generic/congrats.png`} style={{width: '70%'}} />
                                                        :
                                                            null
                                                    }
                                                    <br />
                                                    <Typography sx={{fontSize:'12px'}}>{t("passwordRecovery.descCongrats_1")}</Typography>
                                                    <br /><br />
                                                </Box>
                                            </div>
                                        </Grid>
                                    </Box>
                                    <Box sx={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: "center", alignItems: "stretch",}}>
                                        <div style={{display: (step!=3 && step!=0 ? 'block': 'none'), width: '100%', paddingRight: '5px'}}>
                                            <Button variant="text" sx={{ ...constants.styles.secondaryButton, alignSelf: 'flex-end' }} 
                                                onClick={()=>handleClick_Previous()}
                                            >{t("passwordRecovery.prevButton")}</Button>
                                        </div>
                                        <div style={{display: (step!=3 ? 'block': 'none'), width: '100%', paddingLeft: '5px'}}>
                                            <Button variant="text" sx={{ ...constants.styles.secondaryButton, alignSelf: 'flex-end' }} 
                                                onClick={()=>handleClick_Next()}
                                            >{t("passwordRecovery.nextButton")}</Button>
                                        </div>
                                        <div style={{display: (step===3 ? 'block': 'none'), width: '100%'}}>
                                            <Button variant="text" sx={{ ...constants.styles.mainButton, alignSelf: 'flex-end' }}
                                                onClick={()=>handleClose()}
                                            >{t("passwordRecovery.finalButton")}</Button>
                                        </div>
                                    </Box>
                                </form>
                                    
                                    
                                    
                                    {/* <div class="g-signin2" data-width="300" data-height="200" data-longtitle="true" /> */}
                                
                                
                            </Grid>
                        </Grid>
                </Box>
            </Modal>
        </>
    )
}
